module.exports = [{"type":"title","text":"2025-09-10"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"接口頻率限制改動詳見:<a href='https://bingx-api.github.io/docs/#/zh-tw/swapV2/base-info.html#%E9%A0%BB%E7%8E%87%E9%99%90%E5%88%B6' target='_blank'>頻率限制</a>"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-09-10.json
// module id = erks
// module chunks = 3